import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-bar',
  template: `
    <div class="progress-bar__background">
      <div class="progress-bar__progress" [ngStyle]="{width:( current / max * 100)+'%'}"></div>
    </div>
    <div>
    <div class="progress-bar__values">
      <div class="progress-bar__min">0</div>
      <div class="progress-bar__max">{{ max }} {{ unit }}</div>
    </div>
  `,
  host: {
    class: 'progress-bar'
  }
})
export class ProgressComponent {
  @Input() unit: string;
  @Input() max: number;
  @Input() current: number;
}
